{
  "manager": {
    "modalExport": {
      "startingExport": "Starting your export...",
      "processingTime": "This may take a moment to process.",
      "exportCompleted": "Export Completed Successfully!",
      "readyForDownload": "Your export is ready for download.",
      "recordsExported": "records exported.",
      "downloadExportFile": "Download Export File",
      "exportQueued": "Your export has been queued and is being processed.",
      "emailNotice": "You will receive an email at",
      "emailDownloadLink": "with a download link when it's ready.",
      "processing": "Processing",
      "records": "records.",
      "exportFailed": "Export Failed"
    },
    "exportModal": {
      "title": "Export Data",
      "largeDatasetNotice": "We've detected this is a large dataset. Please enter your email address below and we'll send you a link to download your data.",
      "emailLabel": "Email *",
      "emailDescription": "We will send you a link to download your data.",
      "emailPlaceholder": "Enter email"
    },
    "dailyReporting": {
      "pageTitle": "Daily Report",
      "dateLabel": "Date"
    },
    "transactionList": {
      "title": "Transactions",
      "assignTags": "Assign Tags",
      "removeTags": "Remove Tags",
      "transactionDetails": "Transaction Details",
      "viewBooking": "View Booking",
      "viewInvoice": "View Invoice",
      "partiallyRefunded": "Partially Refunded",
      "fullyRefunded": "Fully Refunded",
      "amountRemaining": "({amount} remaining)",
      "totals": "Totals",
      "refund": "Refund",
      "invoice": "Invoice",
      "tagsLabel": "Tags",
      "assignTagsPlaceholder": "Search existing or type to create",
      "assignTagsInvalid": "Pick at least one tag to apply.",
      "removeTagsLabel": "Tags to remove",
      "removeTagsPlaceholder": "Pick tags to remove",
      "removeTagsInvalid": "Pick at least one tag to remove."
    }
  }
}
